"use strict";

// eslint-disable-next-line no-var
var gtmMap = {
  'article': 'default',
  'pr': 'advertorial',
  'native': 'native',
  'column': 'column',
  'longform': 'longform',
  'gallery': 'gallery',
  'flashcard': 'flashcard',
  'live': 'live',
  'video': 'video',
  '404': '404',
  'weather': 'weather',
  'enigmatic': 'enigmatic'
};
window.getGtmContentType = (dataType, isPremium) => `${gtmMap[dataType]}${isPremium ? '|premium' : ''}`;

/**
 * Sends POST request to 'fapi/analytics/object/<contentType>/<contentId>'
 * when passed `contentType` or `pageType` are matched with one of keys
 * from `objectsForPageCounts`.
 *
 * Other analytics endpoints available for POST :
 *  - 'fapi/analytics/url' - when there is no `coraContentType` for example.
 */
// eslint-disable-next-line no-unused-vars
function sendPageCount(pageType, contentId, contentType, contentTitle) {
  const objectName = contentType === 'author' ? contentType : pageType;
  const objectsForPageCounts = {
    article: 'content.article',
    author: 'authors.detail',
    pieces: 'pieces.piece',
    service: 'pieces.piece',
    gallery: 'galleries.gallery'
  };
  const coraContentType = objectsForPageCounts[objectName] && contentId ? objectsForPageCounts[objectName] : null;
  if (coraContentType) {
    const postData = {
      data: {
        type: 'analytics',
        attributes: {
          url: `${window.location.origin}${window.location.pathname}`,
          title: contentTitle || 'none'
        }
      }
    };
    const headers = {
      'Content-Type': 'application/vnd.api+json'
    };
    if (window.getUserToken()) headers.Authorization = `Bearer ${window.getUserToken()}`;
    fetch(`${window.baseApiUrl}/analytics/object/${coraContentType}/${contentId}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(postData)
    });
  }
}

/**
 * ToDo: 'G360' više ne postoji na portalu pa je donja funkcija nepotrebna.
 * Nepotrebno ispisuje 'console.warn' svaki put kad se pozove.
 * Obrisati i sve reference.
 * send events to google360
 * @param {String} category
 * @param {String} action
 * @param {String} label
 */
window.googleSendEvent = (category, action, label) => {
  if (typeof window.ga === 'function') {
    window.ga('G360.send', 'event', category, action, label);
  } else {
    console.warn('`window.ga` function of Google Analytics not found!');
  }
};

/**
 * send events to Facebook Meta Pixel
 * @param {String} category
 * @param {String} action
 */
window.facebookMetaPixelSendEvent = (category, action) => {
  if (typeof window.fbq === 'function') {
    window.fbq(category, action);
  } else {
    console.warn('`window.fbq` function of Facebook Meta Pixel not found!');
  }
};

/**
 * Used as `contentPublishingDate` key value when `virtualPageView` is
 * pushed to GTM dataLayer
 *
 * Example string: 2020-1-4_cw1_m1_q1_12:02
 */
window.getGtmPublishingDate = value => {
  const date = window.dayjs(value).format('YYYY-M-D');
  const week = window.dayjs(value).week();
  const month = window.dayjs(value).format('M');
  const quarter = window.dayjs(value).quarter();
  const time = window.dayjs(value).format('h:mm');
  return `${date}_cw${week}_m${month}_q${quarter}_${time}`;
};

/**
 * Used as `contentAuthor` and 'pageTags' key value when
 * `virtualPageView` is pushed to GTM dataLayer
 *
 * Example string: "Krešo Kokić|Duje Plazibatić"
 */
window.getTrackingManyString = (objectList, separator = '|') => {
  let manyString = '';
  objectList.forEach((obj, index) => {
    if (index > 0) manyString += separator;
    manyString += obj.name;
  });
  return manyString;
};

/**
 * Pushes data to Google Tag Manager data layer.
 * Basic data is prepared for `virtualPageview` but
 * can be used for push of any kind of event to window.dataLayer.
 */
window.googleTagManagerDataLayerPush = objectData => {
  if (window.dataLayer) {
    const basicData = {
      'event': 'virtualPageview',
      'siteId': '24s',
      'channel': '',
      'contentAuthor': '',
      'contentId': '',
      'contentTitle': '',
      'contentType': 'default',
      'contentElements': 'none',
      'userType': 'non logged user'
    };
    const profileData = window.getProfileData();
    if (profileData) {
      basicData.userType = profileData.piano_subscription_type;
    }
    window.dataLayer.push({
      ...basicData,
      ...objectData
    });
  } else {
    console.warn('[Google Tag Manager] The "window.dataLayer" not found. Please check GTM setup.');
  }
};

/**
 * Pushes `virtualPageview` event to GTM dataLayer for article object.
 * Used on video article feed when changing url upon scroll event.
 */
window.pushArticleGtmVirtualPageView = articleData => {
  const gtmObjectData = {
    pageType: 'article',
    contentId: articleData.id,
    contentTitle: articleData.title,
    contentType: window.getGtmContentType(articleData.article_type, articleData.is_premium),
    contentPublishingDate: window.getGtmPublishingDate(articleData.publish_date)
  };
  try {
    if (articleData.section?.data) {
      gtmObjectData.channel = articleData.section.data.slug;
      gtmObjectData.fullChannel = articleData.section.data.slug;
    }
    if (articleData.subsection?.data) {
      gtmObjectData.fullChannel = `${gtmObjectData.fullChannel}/${articleData.subsection.data.slug}`;
    }
    if (articleData.authors?.data) {
      gtmObjectData.contentAuthor = window.getTrackingManyString(articleData.authors.data);
    }
    if (articleData.keywords?.data) {
      gtmObjectData.pageTags = window.getTrackingManyString(articleData.keywords.data);
    }
    if (articleData.article_type === 'video' || articleData.has_video) {
      gtmObjectData.contentElements = 'video';
    }
  } catch (e) {
    console.error(`[GTM] Something went wrong with preparing dataLayer object: ${e}`);
  }
  window.googleTagManagerDataLayerPush(gtmObjectData);
  return gtmObjectData;
};
window.getUpScoreUserStatus = () => {
  let userStatus = 0;
  const profileData = window.getProfileData();
  if (profileData) {
    userStatus = profileData.daily_digest_newsletter_consent.is_accepted ? 2 : 1;
  }
  return userStatus;
};

/**
 * Sends data to upScore vendor, used in case of page visit.
 */
window.sendUpscoreData = upscoreParameters => {
  const isHomepage = window.location.pathname === '/';
  let contentType = 0;
  let isContentBlocked = 0;
  if (isHomepage) {
    isContentBlocked = '';
    contentType = '';
  } else if (upscoreParameters.isArticlePremium) {
    contentType = 1;
    const profileData = window.getProfileData();
    if (!profileData || !profileData.tagreted_advertisment_consent.is_accepted) {
      isContentBlocked = 1;
    }
  } else if (upscoreParameters.articleSlugValue === 'promo-sadrzaj') {
    contentType = 2;
  }
  if (window.isUpscoreScriptEnabled) {
    window.upScore({
      config: {
        domain: '24sata.hr',
        article: upscoreParameters.articleSelector || '',
        track_positions: 'false' || ''
      },
      data: {
        ...upscoreParameters.baseData,
        ...{
          content_type: contentType,
          content_blocked: isContentBlocked,
          user_status: window.getUpScoreUserStatus()
        }
      }
    });
  } else {
    console.warn('[UpScore]: script is disabled!');
  }
};

/**
 * Prepare Article data to be sent as UpScore event.
 * Used for dynamic purposes, primarily when scrolling through
 * article video feed and changing url per article in view.
 */
window.sendArticleUpscoreData = articleUpscoreData => {
  let objectType = 'article';
  if (articleUpscoreData.articleType === 'video' || articleUpscoreData.videoInside) {
    objectType = `${objectType},video`;
  }
  window.sendUpscoreData({
    articleSelector: '.article__content',
    articleSlugValue: articleUpscoreData.articleSectionSlug,
    isArticlePremium: articleUpscoreData.articleIsPremium,
    baseData: {
      section: articleUpscoreData.articleSectionSlug,
      object_id: articleUpscoreData.objectId,
      pubdate: articleUpscoreData.pubDate || '',
      author: articleUpscoreData.author || '',
      object_type: objectType,
      custom_taxonomy: window.getDfpContentType(articleUpscoreData.articleType),
      custom_sponsored: ['pr', 'native'].includes(articleUpscoreData.articleType) ? '1' : '0',
      custom_userid: ''
    }
  });
};
document.dispatchEvent(new Event('UtilsTrackingLoaded'));